module.exports = __webpack_public_path__ + "img/turntable_pointer.124aa616.png";